import { isJessicaSite } from 'common/constants/siteSelectorConstants'
import { PATH_SEGMENT } from 'routes/pathSegments'

// Jessica sites show the cart and site selector on Home only.
export const shouldShowCartWidget = (siteCode: string | undefined, pathname: string): boolean => {
  if (!isJessicaSite(siteCode)) return true
  return pathname.split('/').filter(Boolean)[1]?.toLowerCase() === PATH_SEGMENT.HOME
}
